import React from 'react'
import Heading from '../Typography/Heading'

const Banner = ({
  heading,
  className,
  children,
  headingClasses,
  contentOffsetClassName = 'pt-48 xl:pt-48 2xl:pt-48',
}) => {
  return (
    <>
    <div className={`${className} w-[100%] h-screen sm:h-[1000px] lg:h-screen relative bg-no-repeat bg-center object-cover bg-cover`}>
    <div className={`tp-container-main mx-auto w-full h-full ${contentOffsetClassName} text-center sm:text-start`}>
          <Heading variant={"h1"} className={`${headingClasses}`}>
            {heading}
          </Heading>
          <>{children}</>
        </div>
      </div>
    </>
  )
}

export default Banner